// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-container {
  color: #5C6166;
  font-style: normal;
  font-family: "pfbeausans", sans-serif;
  width: 600px;
  height: 1056px;
  background-color: #fff;
}
.pdf-container h3 {
  font-family: Helvetica, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  color: #45494D;
}
.pdf-container h4 {
  font-family: Helvetica, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.pdf-container p {
  font-family: Helvetica, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 21px;
  letter-spacing: -0.2px;
  color: #5C6166;
}
.pdf-container .content-container .header {
  height: 88px;
  background: #007A33;
  font-size: 16px;
  line-height: 16px;
  padding: 25px;
}
.pdf-container .content-container .header p {
  color: white;
}
.pdf-container .content-container .header .logo {
  width: 79.82px;
  height: 24.05px;
}
.pdf-container .content-container .table tr td:last-child {
  text-align: right;
}
.pdf-container .content-container .table tr td p {
  line-height: 28px;
  padding: 0;
  margin-bottom: 0;
}
.pdf-container .content-container .banner-email {
  background: #FEF2E0;
  border-radius: 3px;
  align-items: center;
  height: 50px;
}
.pdf-container .content-container .banner-email p {
  font-family: Helvetica, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 160%;
  letter-spacing: -0.02em;
  color: #5C6166;
}
.pdf-container .content-container .footer {
  min-height: 100px;
  font-size: 9px;
  line-height: 19px;
}
.pdf-container .content-container .footer .banner-info {
  padding: 32px 20px;
  background: #FFFFFF;
  border: 1px solid #F4F7F8;
  box-sizing: border-box;
  border-radius: 5px;
}
.pdf-container .content-container .footer .banner-info p {
  font-family: Helvetica, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 175%;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: #5C6166;
}
.pdf-container .content-container .avoid-fraud {
  font-size: 9px;
  line-height: 24px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
